export default {"src":"/_next/static/media/liverpool.7509c59a.svg","height":45,"width":173};